var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChooseIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_118_165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.75 15.8333H20.5833V9.5C20.5833 7.8203 19.9161 6.20939 18.7283 5.02166C17.5406 3.83393 15.9297 3.16667 14.25 3.16667C12.5703 3.16667 10.9594 3.83393 9.77166 5.02166C8.58393 6.20939 7.91667 7.8203 7.91667 9.5V15.8333H4.75V9.5C4.75 6.98044 5.75089 4.56408 7.53249 2.78249C9.31408 1.00089 11.7304 0 14.25 0C16.7696 0 19.1859 1.00089 20.9675 2.78249C22.7491 4.56408 23.75 6.98044 23.75 9.5V15.8333Z",
    fill: "#34CDFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3335 14.25H3.16683C2.29238 14.25 1.5835 14.9589 1.5835 15.8333V33.25C1.5835 34.1245 2.29238 34.8333 3.16683 34.8333H25.3335C26.2079 34.8333 26.9168 34.1245 26.9168 33.25V15.8333C26.9168 14.9589 26.2079 14.25 25.3335 14.25Z",
    fill: "#CCF2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91683 31.6667C7.4969 31.6667 7.09418 31.4999 6.79724 31.2029C6.50031 30.906 6.3335 30.5033 6.3335 30.0833V14.25H3.16683C2.7469 14.25 2.34418 14.4168 2.04724 14.7137C1.75031 15.0107 1.5835 15.4134 1.5835 15.8333V33.25C1.5835 33.6699 1.75031 34.0727 2.04724 34.3696C2.34418 34.6665 2.7469 34.8333 3.16683 34.8333H25.3335C25.7534 34.8333 26.1562 34.6665 26.4531 34.3696C26.75 34.0727 26.9168 33.6699 26.9168 33.25V31.6667H7.91683Z",
    fill: "#99E6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4168 22.1667C17.4173 21.6107 17.2714 21.0644 16.9938 20.5827C16.7162 20.101 16.3167 19.7008 15.8353 19.4225C15.354 19.1442 14.8079 18.9975 14.2519 18.9972C13.696 18.9969 13.1497 19.143 12.6681 19.4207C12.1864 19.6985 11.7864 20.0982 11.5083 20.5796C11.2301 21.061 11.0836 21.6072 11.0835 22.1631C11.0834 22.7191 11.2296 23.2654 11.5076 23.7469C11.7855 24.2284 12.1853 24.6283 12.6668 24.9063V30.0834H15.8335V24.9063C16.3147 24.6289 16.7144 24.2297 16.9924 23.7487C17.2703 23.2678 17.4167 22.7222 17.4168 22.1667Z",
    fill: "#34CDFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 22.1667C12.667 21.4651 12.9005 20.7836 13.3304 20.2292C13.7603 19.6747 14.3622 19.2789 15.0416 19.1037C14.3006 18.9115 13.5151 18.9944 12.8307 19.3371C12.1462 19.6798 11.6092 20.2591 11.3192 20.9675C11.0293 21.6759 11.006 22.4654 11.2538 23.1897C11.5015 23.914 12.0035 24.5238 12.6666 24.9063V30.0834H14.2499V24.9063C13.7686 24.6289 13.3689 24.2296 13.091 23.7487C12.813 23.2678 12.6667 22.7222 12.6666 22.1667Z",
    fill: "#01C0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 38C33.7467 38 38 33.7467 38 28.5C38 23.2533 33.7467 19 28.5 19C23.2533 19 19 23.2533 19 28.5C19 33.7467 23.2533 38 28.5 38Z",
    fill: "url(#paint0_linear_118_165)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4998 31.6666C28.2543 31.6667 28.0121 31.6094 27.7926 31.4992L24.626 29.9159L26.0423 27.0837L27.9587 28.0418L30.3501 24.455L32.9848 26.2115L29.8181 30.9615C29.6735 31.1785 29.4774 31.3564 29.2474 31.4795C29.0174 31.6025 28.7606 31.6668 28.4998 31.6666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_118_165",
    x1: 21.7857,
    y1: 35.2143,
    x2: 35.2143,
    y2: 21.7857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34CDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8D9F1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseIcon04);
export default __webpack_public_path__ + "static/media/choose_icon04.b10f3e20e7bd28a66b3bc682c0611101.svg";
export { ForwardRef as ReactComponent };